import { gql } from '@apollo/client';

export const CORE_GOAL_FIELDS = gql`
  fragment CoreGoalFields on PredictiveAudienceGoal {
    id
    name
    goal
    description
    userProfileField
  }
`;

export const ALL_GOAL_FIELDS = gql`
  fragment AllGoalFields on PredictiveAudienceGoal {
    createdAt
    createdBy
    description
    goal
    goalValidation {
      is_valid
      error_msg
    }
    id
    lastScoredAt
    lastTrainedAt
    name
    status
    updatedAt
    updatedBy
    userProfileField
    modelDetails {
      model_quality
      previous_model_quality
      explainableFeatures {
        features {
          name
          strength
          direction
          featureType
          constituentFeatures {
            name
            weight
          }
        }
      }
      num_users
      lift_at_each_percentile
      prob_at_each_percentile
    }
  }
`;
